import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/plan/query_approval_page";
export const DownloadURL = "/icps/system/sign/basics/plan/exportEngineer";

/*根据工程ID获取工程合同签订主体 */
export function getCollaborationUnit(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getCollaborationUnit",
    method: "post",
    data,
  });
}
/*富余量新增 */
export function saveSurplus(data) {
  return request({
    url: "/icps/surplus/save",
    method: "post",
    data,
  });
}
/*根据计划审核列表id获取用料计划列表*/
export function plan_list(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_list",
    method: "get",
    params,
  });
}
/*根据计划审核列表id获取用料计划列表的头部信息*/
export function plan_table_detail(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_table_detail",
    method: "get",
    params,
  });
}
/*添加计划*/
export function save_or_update(data) {
  return request({
    url: "/icps/system/sign/basics/plan/save_or_update",
    method: "post",
    data,
  });
}
/*添加计划新接口*/
export function savePlan(data) {
  return request({
    url: "/icps/system/sign/basics/plan/savePlan",
    method: "post",
    data,
  });
}
/*获取强度等级和性能要求等。。。*/
export function getLists(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/getLists",
    method: "post",
    data,
  });
}
/*工程图算查询*/
export function get_graphic_manager(data) {
  return request({
    url: "/icps/system/sign/basics/operation/get_graphic_manager",
    method: "post",
    data,
  });
}
/*根据id获取详情信息*/
export function plan_detail(params) {
  return request({
    url: "/icps/system/sign/basics/plan/plan_detail",
    method: "get",
    params,
  });
}

// /*查询泵送，运输，泵管list*/
export function getContractVoList(params) {
  return request({
    url: "/icps/system/sign/dataCollection/contract/getContractVoList",
    method: "get",
    params,
  });
}

// /*根据计划id和工程id获取作业安排信息*/
export function operation_detail(params) {
  return request({
    url: "/icps/system/sign/basics/operation/operation_detail",
    method: "get",
    params,
  });
}
// /*根据工程id获取风险管控信息*/
export function get_assess(params) {
  return request({
    url: "/icps/system/sign/basics/operation/get_assess",
    method: "get",
    params,
  });
}
/*计划审核，同时支持修改订单信息和作业安排,同时修改审核状态*/
export function check_order(data) {
  return request({
    url: "/icps/system/sign/basics/plan/check_order",
    method: "post",
    data,
  });
}
/*历史备注*/
export function planRemark(data) {
  return request({
    url: "/icps/system/sign/intelligent/planRemark/getLists",
    method: "post",
    data,
  });
}
/*设置预算员*/
export function updateBudget(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/updateBudget",
    method: "post",
    data,
  });
}

// 获取工程的管控业务点
export function queryOneResord(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/queryOneResord",
    method: "post",
    data,
  });
}

// 批量取消计划
export function cancelPlanByIds(data) {
  return request({
    url: "/icps/system/sign/basics/plan/cancelPlanByIds",
    method: "post",
    data,
  });
}

// 查询供应阶段或工程阶段
export function controlqueryPhase(data) {
  return request({
    url: "/icps/system/sign/cloudSell/control/queryPhase",
    method: "post",
    data,
  });
}

// 计划审核-供应阶段-修改
export function controlupdatePhase(data) {
  return request({
    url: "/icps/system/sign/cloudSell/control/updatePhase",
    method: "post",
    data,
  });
}
// 计划审核-阶段-添加修改-保存
export function controlsavePhase(data) {
  return request({
    url: "/icps/system/sign/cloudSell/control/savePhase",
    method: "post",
    data,
  });
}
// 计划审核-阶段切换-
export function updatePhaseAndControl(data) {
  return request({
    // url: "/icps/system/sign/cloudSell/control/updatePhaseAndControl",原接口
    url: "/icps/system/sign/cloudSell/control/savePhaseStatus",
    method: "post",
    data,
  });
}
// 阶段作废-
export function concleCompleStatus(data) {
  return request({
    url: "/icps/system/sign/cloudSell/control/concleCompleStatus",
    method: "post",
    data,
  });
}

// 修改责任人
export function updateDisCole(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/updateDisCole",
    method: "post",
    data,
  });
}
// 复核-修改状态
export function controlupdateCheck(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/UpdateFinancialCode",
    method: "post",
    data,
  });
}
// 查询价格信息
export function queryPlanProductCost(data) {
  return request({
    url: "/icps/system/sign/basics/plan/queryPlanProductCost",
    method: "post",
    data,
  });
}
// 查询图算超量异常以及限制
export function getGraException(params) {
  return request({
    url: "/icps/system/sign/basics/plan/getGraException",
    method: "get",
    params,
  });
}
// 修改富余量状态
export function surplusApplay(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringExtend/surplusApplay",
    method: "post",
    data,
  });
}
// 查询工程可选富余量字典
export function queryExcessAllowance(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringExtend/queryExcessAllowance",
    method: "post",
    data,
  });
}

